import { Router } from '@okapi/router-react';
import React from 'react';
import { StoreContext } from 'storeon/react';
import { Baseline } from 'common/components';
import { SeasonStartBathroom } from 'landings/season-start/bathroom-page';
import { RemoteProps } from './widgets-types';

export const SeasonStartBathroomRemote: React.FC<RemoteProps> = ({ router, store }) => (
  /* @ts-expect-error: Router typecheck error */
  <Router router={router}>
    <Baseline>
      <StoreContext.Provider value={store}>
        <SeasonStartBathroom />
      </StoreContext.Provider>
    </Baseline>
  </Router>
);

